module.exports = __webpack_public_path__ + "img/fenxi.0c10fecd.png";